export const FULL_CAMPAIGN_PLAN = "fullCampaignPlan";
export const CAMPAIGN_CREATION_STATUS = "campaignCreationStatus";
export const ALL_SCREENS_FOR_CAMPAIGN_CREATION_SCREEN_OWNER =
  "allScreensForCampaignCreationScreenOwner";
export const UPLOAD_CREATIVE_SCREEN_DATA = "uploadCreativeScreenData";
export const CAMPAIGN_CREATIVES_TO_UPLOAD = "campaignCreativesToUpload";
export const SCREEN_CAMPAIGN_MONITORING_PICS = "screenCampaignMonitoringPics";

export const ALL_SCREENS_LIST = "allScreensList";
export const ALL_CAMPAIGNS_LIST = "allCampaignsList";

export const ALL_NETWORK_LIST = "ALL_NETWORK_LIST";
export const ALL_BRAND_LIST = "ALL_BRAND_LIST";
export const ALL_PACKAGE_LIST = "ALL_PACKAGE_LIST";
